<template>
  <b-container v-if="createAny('users')" fluid>
    <div class="title-bar">
      <h1>{{ $t("titles.nationalities") }}</h1>
      <div @click="edit_nationality({ id: 0 })" class="btn btn-primary">
        <font-awesome-icon icon="plus" /> {{ $t("buttons.addnationality") }}
      </div>
    </div>

    <!-- Table -->
    <b-table :items=nationalities :fields=fields @row-clicked="oncodeClicked">
      <template #cell(actions)="row">
        <div class="action-items">
          <a href="javascript:;" class="btn" @click="delete_a_code(row.item.id)" :title="$t('labels.deletebiccode')">
            <font-awesome-icon icon="trash" /> {{$t('labels.delete')}}
          </a>
        </div>
      </template>
      <template #cell(EU)="row">
        <font-awesome-icon v-if="row.item.EU==1" icon="check"  style="color: green;" />
        <font-awesome-icon v-else icon="times" style="color: red;" />
      </template>
    </b-table>

  </b-container>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import nationality_details_modal from './modals/NationalityModal.vue'
import popup_modal from './modals/PopupModal.vue'

export default {
  name: 'codesscreen',
  data() {
    return {
      selectedID: null,
    }
  },
  computed: {
    fields() {
      return [
      { key: 'code', label: this.$i18n.t('labels.landcode'), sortable: true, sortDirection: 'desc' },
      { key: 'land', label: this.$i18n.t('meta.country'), sortable: true, sortDirection: 'desc' },
      { key: 'nationality', label: this.$i18n.t('titles.nationality'), sortable: true, sortDirection: 'desc' },
      {key:'EU', label: this.$i18n.t('labels.partofUE'), sortable: true, sortDirection: 'desc' },
      { key: 'actions', label: this.$i18n.t('labels.actions') },
      ]
    },

    ...mapState([
      'nationalities',
    ]),
    ...mapGetters([
      'biccode_by_id',
      'confirm_modal',
      'createAny'

    ]),
  },
  async mounted(){
  },

  methods: {
    ...mapActions([
      'delete_biccode',
      'save_biccode'
    ]),
    delete_a_code(id) {
      this.selectedID = id
      let message = this.$i18n.t('labels.confirmdeletehead') + this.biccode_by_id(id).code + this.$i18n.t('labels.confirmdeletetail')
      this.$modal.hide('popup_modal')
      this.$modal.show(popup_modal, {
        message: message,
      }, {
        name: 'popup_modal',
        draggable: false,
        height: 'auto',
        width: '500px'
      }, {
        'before-close': this.modalClose
      })

      this.$emit('close')

    },
    modalClose() {
      if (this.confirm_modal.id == 1) {
        this.delete_biccode(this.selectedID);
        for (let i = 0; i < this.biccodes.length; i++) {
          if (this.biccodes[i].id == this.selectedID) {
            this.biccodes.splice(i, 1);
          }
        }
      }
    },
    oncodeClicked(row) {
      console.log("CLICK",row)
      this.$modal.hide('nationality_details_modal')
      this.$modal.show(nationality_details_modal, {
        id: row.id
      }, {
        name: 'nationality_details_modal',
        draggable: '.popup-header',
        height: 'auto',
        width: '800px'
      })

      this.$emit('close')
    },
    edit_nationality(code) {
      this.$modal.hide('nationality_details_modal')
      this.$modal.show(nationality_details_modal, {
        code_id: code.id,
      }, {
        name: 'nationality_details_modal',
        draggable: '.popup-header',
        height: 'auto',
        width: '800px'
      })

      this.$emit('close')
    },
  },
}
</script>